import { Grow, IconButton } from '@material-ui/core'
import Popover from '@material-ui/core/Popover'
import { createStyles, makeStyles, type Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import LanguageIcon from '@material-ui/icons/Language'
import type React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { setIsUserProfileModalOpen } from 'src/redux/slices/settings'
import { useAppDispatch } from 'src/utils/hooks/reduxHooks'

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		typography: {
			padding: 0,
		},
		userInfo: {
			fontSize: '1rem',
			fontWeight: 700,
			display: 'flex',
			alignItems: 'center',
			color: '#364263',
			'&:hover': {
				cursor: 'pointer',
				textDecoration: 'underline',
			},
		},
	})
)

export default function LanguageButton() {
	const classes = useStyles()
	const dispatch = useAppDispatch()
	const { t: tGridNavbar } = useTranslation('GridNavbar')
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const openUserProfileModal = () => {
		dispatch(setIsUserProfileModalOpen(true))
		handleClose()
	}

	const open = Boolean(anchorEl)
	const id = open ? 'simple-popover' : undefined

	return (
		<div>
			<IconButton
				aria-label="help icon"
				aria-controls="menu-appbar"
				aria-haspopup="true"
				color="inherit"
				onClick={handleClick}
			>
				<LanguageIcon />
			</IconButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				PaperProps={{
					style: { width: '30rem', padding: '16px' },
				}}
				style={{ padding: '1rem 1rem 2rem', marginTop: '0.25rem' }}
				TransitionComponent={Grow}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '1rem',
					}}
				>
					<div style={{ marginLeft: '1.75rem' }}>
						<Typography
							className={classes.typography}
							style={{
								color: 'gray',
								margin: '0.5rem 0',
								fontSize: '0.875rem',
								lineHeight: '1.75',
							}}
						>
							{tGridNavbar('languageText')}
						</Typography>
						<Typography
							className={classes.userInfo}
							onClick={openUserProfileModal}
						>
							{tGridNavbar('openUserInfo')}
						</Typography>
					</div>
				</div>
			</Popover>
		</div>
	)
}
